<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="p01">
<h1 class="part"><a id="page1"></a><a class="hlink" href="#/OEBPS/9780062043740_epub_toc_r1.htm#p01a"><span class="underline">Part I</span></a><br/><img alt="" src="OEBPS/images/9780062043740_L02.png"/><br/><br/><a class="hlink" href="#/OEBPS/9780062043740_epub_toc_r1.htm#p01a"><span class="big">THE PATH INTO THE FOREST</span></a></h1>
<p class="center"><a id="page2"></a><em>The case histories in this book are true, but the names and<br/>identifying details have been changed to protect<br/>the identities of the individuals involved.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062043740_epub_p01_r1.vue?95df29ca